<template>
  <div class="w-full">
    <HeaderCompanies :loading="loading" />
    <div
      class="w-full overflow-x-auto rounded-xl border border-gray-300 bg-white"
    >
      <a-table
        :columns="columns"
        :data-source="companies"
        :pagination="pagination"
        @change="onTableChange"
      >
        <span
          slot="actions_name"
          slot-scope="text, record"
          class="text-sm font-medium text-right whitespace-nowrap flex"
        >
          {{ record.first_name }} {{ record.last_name }}
        </span>

        <span
          slot="actions"
          slot-scope="text, record"
          class="mr-4 flex items-center text-sm font-medium text-right whitespace-nowrap flex"
        >
          <router-link
            :to="`./${record.key}/edit/`"
            class="mx-3 h-6 w-6 p-1 text-blue-600 dark:text-blue-500 shadow rounded cursor-pointer"
            append
          >
            <img class="h-full w-full" src="@/assets/icons/pen.svg" alt="" />
          </router-link>
        </span>
      </a-table>
    </div>
  </div>
</template>
<script>
import HeaderCompanies from '@/components/Dashboard/Companies/HeaderCompanies'
const columns = [
  {
    title: 'Nombre',
    dataIndex: 'name',
    key: 'name',
    sorter: () => {},
  },
  {
    title: 'Código SFC',
    dataIndex: 'sfc_code',
    key: 'sfc_code',
    sorter: () => {},
  },
  {
    title: 'Tipo SFC',
    dataIndex: 'sfc_company_type',
    key: 'sfc_company_type',
    sorter: () => {},
  },
  {
    title: 'Acciones',
    dataIndex: 'actions',
    key: 'actions',
    scopedSlots: { customRender: 'actions' },
  },
]

export default {
  components: {
    HeaderCompanies,
  },
  data() {
    return {
      actualUser: null,
      companies: [],
      columns,
      loading: false,
      showDeleteModal: false,
      page: 1,
      pageSize: 10,
      totalItems: 10,
      pagination: {
        total: 1,
        current: 1,
        pageSize: 20,
        hideOnSinglePage: true,
      },
      query: {
        page: 1,
        page_limit: 20,
        order_by: undefined,
        direction: undefined,
      },
      loadingStatus: false,
    }
  },
  created() {
    this.setQuery()
    this.fetchCompanies()
  },
  watch: {
    '$route.query': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.fetchCompanies()
      }
    },
  },
  methods: {
    async fetchCompanies() {
      this.loading = true
      const query = this.$route.query

      let response = await this.$api.companies.getCompanies(query)

      if (response.status !== 200) {
        this.$showNotification('error', response.data)
        return
      }
      this.totalItems = response.data.num_total_elements
      this.companies = response.data.result
      this.loading = false
    },
    onTableChange(...params) {
      const pagination = params[0]
      const filters = params[1]
      const sort = params[2]
      // Sort
      if (sort.order) {
        this.query.order_by = sort.field
        this.query.direction = sort.order === 'ascend' ? 'asc' : 'desc'
      } else {
        this.query.order_by = undefined
        this.query.direction = undefined
      }
      // Filters
      if (filters) {
        for (let filter in filters) {
          this.query[filter] = filters[filter]
        }
      }
      // Pagination
      this.pagination.current = pagination.current
      this.query.page = pagination.current
      this.query.page_limit = pagination.pageSize
      this.setQuery(true)
    },
    async setQuery(updateQuery) {
      if (!this.$route.query.page || updateQuery) {
        await this.$router.push({
          query: { ...this.query },
        })
      } else {
        this.pagination.page = this.$route.query.page
        this.pagination.page_limit = this.$route.query.page_limit || 20
        await this.setQuery(true)
      }
    },
    toggleDeleteModal(user) {
      this.actualUser = user
      this.showDeleteModal = !this.showDeleteModal
    },
  },
}
</script>
